<script>
import CardClient from '@/components/Board/CardClient.vue'
import UserResource from '@/resources/user.js'

export default {
  name: 'BoardClientActions',
  components: {
    CardClient
  },
  data () {
    return {
      loading: false,
      clients: [],
      searchQuery: '',
      searchError: '',
      activeFilters: ['all'],
      hasSearched: false,
    }
  },
  computed: {
    filteredClients () {
      if (this.activeFilters.includes('all')) return this.clients

      return this.clients.filter(client => {
        if (!client.actions || typeof client.actions !== 'object') return false
        return this.activeFilters.some(filterValue => {
          const option = FILTER_OPTIONS.find(f => f.value === filterValue)
          return option && option.apiKey && client.actions[option.apiKey]
        })
      })
    },
  },
  created () {
    this.loadClients()
  },
  methods: {
    async loadClients () {
      this.loading = true
      try {
        const response = await UserResource.getClientsForDashboard()
        if (response.status === 200) {
          this.clients = response.data
        }
      } catch (error) {
        console.error('Erreur lors du chargement des clients:', error)
      } finally {
        this.loading = false
      }
    },
    async searchClient () {
      const query = this.searchQuery.trim()
      if (!query) return
      this.loading = true
      this.searchError = ''
      this.hasSearched = true
      try {
        const response = await UserResource.searchClients(query)
        if (response.status === 200) {
          this.clients = response.data
        }
      } catch (error) {
        this.searchError = (error.response && error.response.data && error.response.data.error)
          ? error.response.data.error
          : 'Une erreur est survenue lors de la recherche.'
      } finally {
        this.loading = false
      }
    },
    removeClient (clientId) {
      this.clients = this.clients.filter(c => c.id !== clientId)
    }
  }
}
</script>

<template>
	<section class="board-client-actions">
		<header class="board-client-actions__header">
			<h2 class="dashboard-title dashboard-title--medium">Vos clients</h2>

			<div class="board-client-actions__search">
				<input
			        id="search_clients"
					v-model="searchQuery"
					type="text"
					class="board-client-actions__search-input search-form__input"
					placeholder="Quels clients cherchez-vous ?"
					@keyup.enter="searchClient"
				>
				<button class="board-client-actions__search-btn" @click="searchClient">
					Rechercher
				</button>
			</div>
		</header>

		<div v-if="searchError" class="board-client-actions__error">
			{{ searchError }}
		</div>

		<div v-if="loading" class="dashboard-loading">
			Chargement...
		</div>

		<div v-else-if="hasSearched && filteredClients.length === 0" class="dashboard-empty">
			Aucun client trouvé
		</div>

		<div v-else class="dashboard-grid dashboard-grid--auto-fill">
			<CardClient
				v-for="client in filteredClients"
				:key="client.id"
				:user="client"
				@renewal-updated="removeClient"
			/>
		</div>
	</section>
</template>

<style scoped>
.board-client-actions {
	width: 100%;
  margin: 2rem 0;
}

.board-client-actions__header {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin-bottom: 1.5rem;
}

.board-client-actions__search {
	display: flex;
  justify-content: center;
  padding: 0rem;
	gap: 0.5rem;
	align-items: center;
}

.board-client-actions__search-input {
	max-width: 400px;
  width: 100%;
	padding: 1rem;
	border: 1px solid #ddd;
	border-radius: 999px;
	font-size: 0.9rem;
	outline: none;
	transition: border-color 0.2s;
}

.board-client-actions__search-input:focus {
	border-color: #AF9376;
}

.board-client-actions__search-btn {
	padding: 0.75rem;
	background-color: #AF9376;
	color: white;
	border: none;
 	border-radius: 8px;
	font-size: 0.9rem;
	cursor: pointer;
	transition: background-color 0.2s;
  	display: block;
}

.board-client-actions__search-btn:hover {
	background-color: #8B7355;
}

.board-client-actions__spinner {
	width: 20px;
	height: 20px;
	border: 3px solid #ddd;
	border-top-color: #AF9376;
	border-radius: 50%;
	animation: spin 0.8s linear infinite;
}

@keyframes spin {
	to { transform: rotate(360deg); }
}

.board-client-actions__error {
	background-color: #FEF2F2;
	color: #991B1B;
	border: 1px solid #FECACA;
	border-radius: 8px;
	padding: 1rem;
	margin-bottom: 1rem;
	font-size: 0.9rem;
}

.search-form__input {
  width: 100%;
  padding: 0.75rem ;
  font-family: "Lato", sans-serif;
  font-size: 1rem;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  background-color: #FFFFFF;
  color: #000000;
  transition: all 0.2s ease;
}

</style>



// WEBPACK FOOTER //
// BoardClientActions.vue?41b3d914